
import { useAuth } from "@/lib/auth-context";
import { useGroups } from "@/hooks/useGroups";
import { Badge } from "@/components/ui/badge";

interface PageHeaderProps {
  title: string;
  description?: string;
}

export function PageHeader({ title, description }: PageHeaderProps) {
  const { user } = useAuth();
  const { groups } = useGroups();

  const userGroups = user?.groupIds.includes("all")
    ? groups
    : groups.filter((g) => user?.groupIds.includes(g.id));

  const isAll = user?.groupIds.includes("all");

  return (
    <div>
      <h1 className="text-2xl font-bold">{title}</h1>
      {description && <p className="text-muted-foreground">{description}</p>}
      <div className="flex flex-wrap gap-1.5 mt-2">
        {isAll ? (
          <Badge variant="outline" className="text-xs border-[var(--primary)]/30 text-[var(--primary)]">
            Všechny restaurace ({groups.length})
          </Badge>
        ) : (
          userGroups.map((g) => (
            <Badge key={g.id} variant="outline" className="text-xs border-[var(--primary)]/30 text-[var(--primary)]">
              {g.name}
            </Badge>
          ))
        )}
      </div>
    </div>
  );
}
